import { Loader2, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { useDeleteUserMutation } from "@/hooks/useDeleteUserMutation";

interface DeleteUserButtonProps {
  userId: string;
  disabled?: boolean;
}

export const DeleteUserButton = ({
  userId,
  disabled = false,
}: DeleteUserButtonProps) => {
  const mutation = useDeleteUserMutation();

  const handleDelete = () => {
    toast("Are you sure?", {
      description: "This action cannot be undone.",
      action: {
        label: "Delete",
        onClick: () => mutation.mutate(userId),
      },
      cancel: {
        label: "Cancel",
        onClick: () => undefined,
      },
    });
  };

  return (
    <Button
      variant="ghost"
      size="icon"
      type="button"
      disabled={disabled || mutation.isPending}
      onClick={handleDelete}
      className={cn(
        "h-8 w-8 cursor-pointer text-muted-foreground hover:text-destructive",
        mutation.isPending && "opacity-50",
      )}
      aria-label="Delete user"
    >
      {mutation.isPending ? (
        <Loader2 className="h-4 w-4 animate-spin" />
      ) : (
        <Trash2 className="h-4 w-4" />
      )}
    </Button>
  );
};
